export const WORK_STATUS_EVENT = 'do-chat:work-status'

export function publishWorkStatus(workStatus) {
  if (!workStatus?.tasks?.length || typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent(WORK_STATUS_EVENT, { detail: workStatus }))
}

export function pollProposalWorkStatus(fetchProposal, proposalId, onRow) {
  if (typeof window === 'undefined') return null
  return window.setInterval(() => {
    void fetchProposal({ proposalId })
      .then((row) => {
        publishWorkStatus(row.workStatus)
        onRow(row)
      })
      .catch(() => {})
  }, 750)
}
